// Utility to view persisted debug logs
// Call viewLogs() in browser console to see all logs
import * as Sentry from "@sentry/react";

const { logger } = Sentry;

export const viewLogs = () => {
  try {
    const redirectLogs = JSON.parse(localStorage.getItem('leebai_redirect_log') || '[]');
    const debugLogs = JSON.parse(localStorage.getItem('leebai_debug_log') || '[]');
    
    logger.info('PERSISTED DEBUG LOGS', {
      redirectCount: redirectLogs.length,
      debugCount: debugLogs.length
    });
    
    if (redirectLogs.length > 0) {
      redirectLogs.forEach((log, i) => {
        logger.warn(`Redirect log [${i + 1}]`, log);
      });
    } else {
      logger.info('No redirects detected');
    }
    
    if (debugLogs.length > 0) {
      debugLogs.forEach((log, i) => {
        const logMethod = log.level === 'error' ? logger.error : log.level === 'warn' ? logger.warn : logger.info;
        logMethod(`Debug log [${i + 1}] [${log.category}] ${log.message}`, log.data);
      });
    } else {
      logger.info('No debug logs found');
    }
    
    return {
      redirects: redirectLogs,
      debug: debugLogs,
    };
  } catch (e) {
    Sentry.captureException(e);
    logger.error('Error reading logs', { error: e.message });
    return null;
  }
};

export const clearLogs = () => {
  localStorage.removeItem('leebai_redirect_log');
  localStorage.removeItem('leebai_debug_log');
  logger.info('Logs cleared');
};

// Make it available globally
if (typeof window !== "undefined") {
  window.viewLogs = viewLogs;
  window.clearLogs = clearLogs;
}
